import { render, staticRenderFns } from "./PointBalance.vue?vue&type=template&id=a83072d0"
import script from "./PointBalance.vue?vue&type=script&lang=js"
export * from "./PointBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports